<script setup>

import { defineProps, defineEmits, ref, computed, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilNumber from "@/utils/UtilNumber";
import UtilObject from "@/utils/UtilObject";
import UtilDateTime from "@utils/UtilDateTime";
import UtilID from "@/utils/UtilID";
import ERP from "@/api/v2/ERP.mjs";
import View from "@/api/v2/View.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "dado",
    "controlesDesativados",
    "revisandoDado",
]);

const emits = defineEmits([
    "update:alteraDado",
    "update:alteraControlesDesativados",
    "update:alteraRevisandoDado",
]);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================== NCMs ==============================//
//==================================================================//

const ncms = ref([]);

//==================================================================//
//======================= Tipos de Transporte ======================//
//==================================================================//

const tiposDeTransporte = ref([]);

//==================================================================//
//==================== Itens Tipos de Equipamento ==================//
//==================================================================//

const itensTiposDeEquipamento = ref([]);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=========================== Loaded NCMs ==========================//
//==================================================================//

const loadedNCMs = ref(false);

//==================================================================//
//==================== Loaded Tipos de Transporte ==================//
//==================================================================//

const loadedTiposDeTransporte = ref(false);

//==================================================================//
//================ Loaded Itens Tipos de Equipamento ===============//
//==================================================================//

const loadedItensTiposDeEquipamento = ref(false);


//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=================== Altera Controles Desativos ===================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//================== Altera Revisando Dado =========================//
//==================================================================//

const alteraRevisandoDado = (update) =>{

    emits('update:alteraRevisandoDado',update);

};

//==================================================================//
//==================== Altera Dado de Compra =======================//
//==================================================================//

const alteraDado = (update) => {

    emits('update:alteraDado',{
        ...props.dado,
        ...update
    });

};


//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//========================= Mostra Modal ===========================//
//==================================================================//

const mostraModal = computed(()=>{

    // Se o Modal não foi ativado.
    if(props.revisandoDado == false){
        return false;
    }

    // Se não Terminou de Carregar NCM
    if(loadedNCMs.value == false){
        return false;
    }

    // Se não Terminou de Carregar Tipos de Transporte
    if(loadedTiposDeTransporte.value == false){
        return false;
    }

    // Se não Terminou de Carregar Itens Tipos de Equipamento
    if(loadItensTiposDeEquipamento.value == false){
        return false;
    }

    return true;

});


//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================ Altera NCMs =========================//
//==================================================================//

const alteraNCMs = (update = []) =>{
  
    ncms.value = update;

};

//==================================================================//
//===================== Altera Tipos de Transporte =================//
//==================================================================//

const alteraTiposDeTransporte = (update = []) =>{
  
    tiposDeTransporte.value = update;

};

//==================================================================//
//================ Altera Itens Tipos de Equipamento ===============//
//==================================================================//

const alteraItensTiposDeEquipamento = (update = []) =>{
  
    itensTiposDeEquipamento.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//======================== Altera Loaded NCMs ======================//
//==================================================================//

const alteraLoadedNCMs = (update = false) =>{
  
    loadedNCMs.value = update;

};

//==================================================================//
//================= Altera Loaded Tipos de Transporte ==============//
//==================================================================//

const alteraLoadedTiposDeTransporte = (update = false) =>{
  
    loadedTiposDeTransporte.value = update;

};

//==================================================================//
//============= Altera Loaded Itens Tipos de Equipamento ===========//
//==================================================================//

const alteraLoadedItensTiposDeEquipamento = (update = false) =>{
  
    loadedItensTiposDeEquipamento.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=========================== Load NCMs ============================//
//==================================================================//

const loadNCMs = async () =>{
  
    const ncms = await ERP.getManyWithView(View.JOB_NCMS);

    alteraNCMs(ncms?.data);

    alteraLoadedNCMs(true)

};

//==================================================================//
//==================== Load Tipos de Transporte ====================//
//==================================================================//

const loadTiposDeTransporte = async () =>{
  
    const tiposDeTransporteResponse = await ERP.getManyWithView(View.JOB_TIPOS_DE_TRANSPORTE);

    alteraTiposDeTransporte(tiposDeTransporteResponse?.data);

    alteraLoadedTiposDeTransporte(true)

};

//==================================================================//
//================ Load Itens Tipos de Equipamento =================//
//==================================================================//

const loadItensTiposDeEquipamento = async() =>{
  
    const itensTiposDeEquipamentoResponse = await ERP.getManyWithView(View.JOB_ITEM_TIPOS_DE_EQUIPAMENTO);

    alteraItensTiposDeEquipamento(itensTiposDeEquipamentoResponse?.data);

    alteraLoadedItensTiposDeEquipamento(true);

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=================== Pega Item Proxima Sequencia ==================//
//==================================================================//

const pegaItemProximaSequencia = () => {

    let itemUltimo = props?.dado?.itens?.at(-1);
    let itemUltimoSequencia = parseInt(itemUltimo?.sequencia,10) || 0;

    let itemNovaSequencia = `${itemUltimoSequencia+1}` || "1";
    let itemNovaSequenciaFormatada = itemNovaSequencia?.padStart(3,"0");

    return itemNovaSequenciaFormatada;

};

//==================================================================//
//======================= Adiciona Item ============================//
//==================================================================//

const adicionaItem = (update) => {

    let itens = props?.dado?.itens;

    itens.push({
        id: UtilID.generateDateTimeID(),
        aberto: false,
        salvo: false,
        remover: false,
        rascunho: true,
        status: "Em desenvolvimento",
        sequencia: pegaItemProximaSequencia(),
        tipoDeEquipamento: {},
        descricao: "",
        dataPrazoEntrega: UtilDateTime.todayUTC(),
        dataPrazoEntregaFormatada: UtilDateTime.todayBrazil(),
        quantidade: 1,
        precoUnitario: 0,
        precoTotal: 0,
        valorBaseICMS_ISS: 0,
        porcentagemICMS: 0,
        valorICMS: 0,
        porcentagemIPI: 0,
        valorIPI: 0,
        porcentagemISS: 0,
        valorISS: 0,
        itens: [],
        itensQuantidade: 0
    });

    alteraDado({
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//======================== Remove Item =============================//
//==================================================================//

const removeItem = (update) =>{

    let itens = props?.dado?.itens?.map((item)=>{

        if(item.id != update.id){
            return item;
        }

        item = { ...item, ...update };

        item.remover = item?.remover ? false : true;

        item.itens = item?.itens?.filter(subItem => subItem.rascunho !== true);

        item.itens = item?.itens?.map((subItem)=>{

            subItem.remover = true;

            return subItem;

        });

        return item;

    });

    alteraDado({
        itens: itens
    });

};

//==================================================================//
//======================= Descarta Item ============================//
//==================================================================//

const descartaItem = (update) =>{

    let itens = props?.dado?.itens?.filter(item => item.id !== update.id);

    alteraDado({
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) => {

    let itens = props?.dado?.itens?.map((item)=>{

        if(item.id != update.id){
            return item;
        }

        // Altere o Item.
        item = UtilObject.merge(item, update);

        // Calcula o Preço Total do Item.
        item.precoTotal = item.quantidade * item.precoUnitario;

        // Atualiza o Valor de Base ICMS/ISS do Item.
        // Apenas atualiza se: Quantidade ou Preço Unitário forem alterados.
        if(update?.quantidade || update?.precoUnitario){
            item.valorBaseICMS_ISS = item.precoTotal;
        }

        // Atualiza o Valor dos Impostos dos Item.
        item.valorICMS = UtilNumber.getValueFromPercentage({porcentagem:item.porcentagemICMS, valor: item.valorBaseICMS_ISS});
        item.valorIPI = UtilNumber.getValueFromPercentage({porcentagem:item.porcentagemIPI, valor: item.precoTotal});
        item.valorISS = UtilNumber.getValueFromPercentage({porcentagem:item.porcentagemISS, valor: item.valorBaseICMS_ISS});

        return item;

    });

    alteraDado({
        itens: itens
    });

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//================= Pega Subitem Proxima Sequencia =================//
//==================================================================//

const pegaSubitemProximaSequencia = (item)=>{

    let subItemUltimo = item?.itens?.at(-1);
    let subItemUltimoSequencia = parseInt(subItemUltimo?.sequencia,10) || 0;

    let subItemNovaSequencia = `${subItemUltimoSequencia+1}` || "1";
    let subItemNovaSequenciaFormatada = subItemNovaSequencia?.padStart(3,"0");

    return subItemNovaSequenciaFormatada;

};

//==================================================================//
//====================== Adiciona Subitem ==========================//
//==================================================================//

const adicionaSubitem = (update) =>{

    let itens = props?.dado?.itens?.map((item)=>{

        if(item?.id != update?.id){
            return item;
        }

        item.itens.push({
            id: UtilID.generateDateTimeID(),
            salvo: false,
            remover: false,
            rascunho: true,
            sequencia: pegaSubitemProximaSequencia(item),
            status: "Em desenvolvimento",
            descricao: "",
            quantidade: 1,
            valorUnitario: 0,
            valorTotal: 0,
        });

        item.aberto = true;
        item.itensQuantidade = item.itens.length;

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update) =>{

    let itens = props?.dado?.itens?.map((item)=>{

        if(item.id != update.item.id){
            return item;
        }

        item.itens = item?.itens?.map((subItem)=>{

            if(subItem.id != update.subItem.id){
                return subItem;
            }

            subItem = { ...subItem, ...update.subItem };

            subItem.remover = subItem?.remover ? false : true;

            return subItem;

        });

        return item;

    });

    alteraDado({
        itens: itens
    });

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update) =>{

    let itens = props?.dado?.itens?.map(item => {

        if(item.id != update?.item?.id){
            return item;
        }

        item.itens = item?.itens?.filter(subItem => subItem.id !== update?.subItem?.id);
        item.itensQuantidade = item?.itens?.length;

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update) => {

    let itens = props?.dado?.itens?.map((item)=>{

        if(item.id != update.item.id){
            return item;
        }

        item.itens = item?.itens?.map((subItem)=>{

            if(subItem.id != update.subItem.id){
                return subItem;
            }

            subItem = {
                ...subItem,
                ...update.subItem
            }

            subItem.valorTotal = subItem.quantidade * subItem.valorUnitario;

            return subItem;

        });
    
        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = async ()=>{

    await loadNCMs();
    await loadTiposDeTransporte();
    await loadItensTiposDeEquipamento();

}

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//===================== Watch => revisandoDado =======================//
//====================================================================//

watch(()=> props?.revisandoDado, async() => {

    if(props?.revisandoDado == true){
        await preparaModal();
    }

},{ immediate: true });


</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="mostraModal"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="props.dado"
                    :revisandoDado="props.revisandoDado"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraRevisandoDado="alteraRevisandoDado"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="props.dado"
                    :revisandoDado="props.revisandoDado"
                    :ncms="ncms"
                    :tiposDeTransporte="tiposDeTransporte"
                    :itensTiposDeEquipamento="itensTiposDeEquipamento"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraDado="alteraDado"
                    @update:adicionaItem="adicionaItem"
                    @update:removeItem="removeItem"
                    @update:descartaItem="descartaItem"
                    @update:alteraItem="alteraItem"
                    @update:adicionaSubitem="adicionaSubitem"
                    @update:removeSubitem="removeSubitem"
                    @update:descartaSubitem="descartaSubitem"
                    @update:alteraSubitem="alteraSubitem"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>